function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/~/@babel/runtime/helpers/builtin/interopRequireDefault.js
// module id = 40
// module chunks = 114276838955818